import * as React from "react";
import { BarChart } from "@mui/x-charts/BarChart";

export default function LastestBarChart(props) {
  return (
    <div>
      <div>
        <h3>{props.forecastDate}预测值</h3>
        <BarChart
          layout="horizontal"
          height={450}
          yAxis={[
            {
              scaleType: "band",
              data: [
                "规上工业增加值",
                "固定资产投资",
                "社会消费品零售总额",
                "出口",
                "进口",
                "CPI",
                "PPI",
                "本外币各项贷款余额",
              ],
            },
          ]}
          series={[
            {
              label: "广东省",
              data: props.gdData,
              color: "#392f30",
            },
          ]}
          margin={{ top: 55, right: 40, bottom: 40, left: 150 }}
        />
      </div>
      <div>
        <h3>{props.forecastDate}预测值</h3>
        <BarChart
          layout="horizontal"
          height={450}
          yAxis={[
            {
              scaleType: "band",
              data: [
                "规上工业增加值",
                "固定资产投资",
                "社会消费品零售总额",
                "出口",
                "进口",
                "CPI",
                "PPI",
                "本外币各项贷款余额",
              ],
            },
          ]}
          series={[
            {
              label: "深圳市",
              data: props.szData,
              color: "#8b0012",
            },
          ]}
          margin={{ top: 55, right: 40, bottom: 40, left: 150 }}
        />
      </div>
<p className="updateDate" style={{ marginTop: "10px" }}>
  注：图中所示为广深地区的累计同比与当月同比数据，其预测模型与珠三角九市所采用的方法存在差异，具体解释详见“常见问题”与“相关研究”部分。
</p>

      <p className="updateDate">更新时间：{props.updateDate}</p>
    </div>
  );
}
